module.exports = __webpack_public_path__ + "static/img/senior.4d2ea5de.png";